export const Display_Store_Brand_Info = "Display_Store_Brand_Info";
export const Display_Store_Brand_Not_Found = "Display_Store_Brand_Not_Found";
export const Reset_Brand_Info = "Reset_Brand_Info";
export const Getting_Brand_Info = "Getting_Brand_Info";
export const Update_Contact_Form_Email_Status = "Update_Contact_Form_Email_Status";
export const Reset_Contact_Form_Email_Status = "Reset_Contact_Form_Email_Status";
export const Contact_Form_Email_Requested = "Contact_Form_Email_Requested";
export const Contact_Form_Email_Request_Has_Response = "Contact_Form_Email_Request_Has_Response";
export const Update_ReCaptcha_Validation_Result = "Update_ReCaptcha_Validation_Result";
